import { render, staticRenderFns } from "./OcrExecutionDialog.vue?vue&type=template&id=204de62f&"
import script from "./OcrExecutionDialog.vue?vue&type=script&lang=ts&"
export * from "./OcrExecutionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VImg,VSpacer})
